import AppConfig from '../plugins/config/AppConfig'
import moment from 'moment-timezone'
const config = AppConfig.load()
const baseURL = config.BASE_URL

export function dateFormat(date, format = 'MM/DD/YY') {
  return moment(date).format(format)
}

export function onReset(form) {
  Object.keys(form).forEach(key => {
    if (key == 'emails') form[key] = []
    else form[key] = ''
  })
}

export function toggleFullScreen() {
  let doc = window.document
  let docEl = doc.documentElement

  let requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.msRequestFullscreen
  let cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen

  if (
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement
  ) {
    requestFullScreen.call(docEl)
  } else {
    cancelFullScreen.call(doc)
  }
}

export function createFormData(params) {
  let formData = new FormData()

  Object.keys(params).forEach(key => {
    if (Array.isArray(params[key])) {
      return formData.append(key, JSON.stringify(params[key]))
    } else {
      return formData.append(key, params[key])
    }
  })

  return formData
}

export function getFullPath(path) {
  return baseURL + path.replace(/#/g, '%23')
}

export function getColorByStatus(status) {
  const colors = {
    CREATED: 'info',
    IN_PROCESS: 'blue',
    PROCESSED: 'green',
    WARNING: 'orange',
    EXPIRED: 'red',
  }
  return colors[status]
}

export function getLabelByStatus(status) {
  const labels = {
    CREATED: 'OK',
    IN_PROCESS: 'EN PROCESO',
    PROCESSED: 'PROCESADA',
    WARNING: 'POR EXPIRAR',
    EXPIRED: 'EXPIRADA',
  }
  return labels[status]
}

export function getColorByTransitStatusClient(item) {
  let color = '#69ac5b'
  if (item.checkCase === 'NO' || item.checkCase === null) {
    color = '#c2c2c2'
  } else if (item.fdApproved === 'NO') {
    color = '#cf5e3f'
  } else if (item.fdApproved === 'YES' && item.delivered === null) {
    color = '#69ac5b'
  } else if (item.admissionDate !== null && item.departureDate === null) {
    color = '#e1c587'
  } else if (item.delivered === 'YES') {
    color = '#9742e0'
  } else if (item.checkCase === 'YES' && item.fdApproved === null) {
    color = '#299de0'
  }
  return color
}

export function getLabelByTransitStatus(item) {
  let label = 'APROBADA'
  if (item.checkCase === 'NO' || item.checkCase === null) {
    label = 'SIN VALIJA'
  } else if (item.fdApproved === 'NO') {
    label = 'RECHAZADA'
  } else if (item.fdApproved === 'YES' && item.delivered === null) {
    label = 'APROBADA'
  } else if (item.admissionDate !== null && item.departureDate === null) {
    label = 'FYD'
  } else if (item.delivered === 'YES') {
    label = 'ENTREGADA'
  } else if (item.checkCase === 'YES' && item.fdApproved === null) {
    label = 'VALIJA LISTA'
  }
  return label
}
